// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledEmptyItem = styled('div')(
  () => css`
    width: 100%;
    .empty-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        margin-top: 30px;
        text-align: center;
      }
      p {
        color: #0c395a;
      }
      div {
        color: #6c879b;
        font-style: normal;
        font-weight: 700;
        font-size: 0.875rem;
        line-height: 24px;
        span {
          text-decoration: underline;
          color: #4c6fff;
          cursor: pointer;
        }
      }
      @media only screen and (max-width: 400px) {
        img {
          width: 100%;
        }
      }
    }
  `
);
